import React from "react"
import { useFormContext } from "react-hook-form"
import Button from "../../atoms/button/button"
import emailReguex from "../../../utils/emailRegex"
import "./change-email-content.scss"

const ChangeEmailContent = ({ onSubmit, isLoading}) => {
  const { register, errors, watch, handleSubmit } = useFormContext()
  return (
    <div className="f-change-email">
      <h3 className="f-title-modal">¿Quieres cambiar tu correo?</h3>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="f-form-change-email">
          <div className="f-input-container">
            <label className="f-input-indicator" htmlFor="email-change">
              ¿Cúal es tu nuevo correo?
            </label>
            <input
              id="email-change"
              className={` f-input ${errors?.email ? "f-error-validation" : ""}`}
              name="email"
              ref={register({
                required: { value: true, message: "Email Invalido" },
                pattern: { value: emailReguex(), message: "Email Invalido" },
              })}
            />
            {errors?.email && (
              <span className="f-error-code">{errors?.email.message}</span>
            )}
          </div>
          <div className="f-input-container">
            <label className="f-input-indicator" htmlFor="confirm-email-change">
              Confirma tu nuevo correo
            </label>
            <input
              id="confirm-email-change"
              name="confirmEmail"
              className={` f-input ${
                errors?.confirmEmail ? "f-error-validation" : ""
              }`}
              ref={register({
                required: { value: true, message: "Email Invalido" },
                pattern: { value: emailReguex(), message: "Email Invalido" },
                validate: {
                  value: value => value === watch("email") || "Email Invalido",
                },
              })}
            />

            {errors?.confirmEmail && (
              <span className="f-error-code">
                {errors?.confirmEmail.message}
              </span>
            )}
          </div>
        </div>
        <div className="f-buttons-container">
          <Button
            className={`primary-pink short ${isLoading? "disabled" : ""}`}
            title="Siguiente"
            type="submit"
            disable={isLoading}
          />
        </div>
      </form>
    </div>
  )
}

export default ChangeEmailContent
